<template>
  <vxe-modal v-model="visible" :title="title" type="confirm" width="60%" @confirm="confirm">
    <template v-if="selectedRows.length > 0">
      <vxe-button icon="vxe-icon-square-close-fill" mode="text" size="mini" status="primary" @click="closeTag()"/>
      <template v-for="row in selectedRows">
        <a-tooltip v-if="row.name.length > 10" :key="row.id" :title="row.name">
          <a-tag :key="row.id" :closable="true" color="blue" @close="() => closeTag(row)">
            {{`${row.name.slice(0, 10)}...`}}
          </a-tag>
        </a-tooltip>
        <a-tag v-else :key="row.id" :closable="true" color="blue" @close="() => closeTag(row)">
          {{row.name}}
        </a-tag>
      </template>
    </template>
    <vxe-table
      ref="table"
      :data="data"
      :loading="loading"
      :min-height="500"
      @checkbox-all="({checked})=>checkAll(checked)"
      @checkbox-change="({checked, row})=>changeCheckbox(checked, row)"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column :type="selectType" fixed="left" width="40"/>
      <vxe-column v-if="showNo" field="no" title="business.label.no"/>
      <vxe-column v-if="showName" field="name" title="business.label.name"/>
      <vxe-column v-if="showValue" field="value" title="business.label.value"/>
    </vxe-table>
  </vxe-modal>
</template>
<script>
import { findOne } from '@/api/Api'

export default {
  name: 'FieldModal',
  data() {
    return {
      visible: false,
      loading: false,
      data: [],
      query: { no: '' },
      args: null,
      record: undefined,
      selectedRows: []
    }
  },
  props: {
    selectType: {
      type: String,
      default: 'radio'
    },
    no: {
      type: String
    },
    title: {
      type: String,
      default: ''
    },
    showName: {
      type: Boolean,
      default: true
    },
    showNo: {
      type: Boolean,
      default: true
    },
    showValue: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    init(args) {
      this.query = { 'no': '' }
      this.data = []
      this.selectedRows = []
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e, selectedRows) {
      this.init(args)
      this.record = e
      if (this.selectType === 'checkbox' && selectedRows && selectedRows.length > 0) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
      }
      this.visible = true
      this.refresh()
    },
    refresh() {
      this.loading = true
      this.query.no = this.no
      findOne('fieldFactory', this.query).then(res => {
        if (res.success) {
          this.data = res.result.dictionaries
          if (this.selectedRows.length > 0) {
            this.$refs.table.setCheckboxRow(this.selectedRows, true)
          }
        }
      }).finally(() => this.loading = false)
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        const radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        if (this.selectedRows.length > 0) {
          selectedRows = this.selectedRows
        } else {
          selectedRows = this.$refs.table.getCheckboxRecords()
        }
      }
      this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    closeTag(row) {
      if (row) {
        this.$refs.table.setCheckboxRow(row, false)
      } else {
        this.$refs.table.clearCheckboxRow()
      }
      this.removeSelectedRow(row)
    },
    addTag(row) {
      if (this.selectedRows.findIndex(item => item.id === row.id) === -1) {
        this.selectedRows.push(row)
      }
    },
    removeSelectedRow(row) {
      if (row) {
        this.selectedRows = this.selectedRows.filter(item => item.id !== row.id)
      } else {
        this.selectedRows = []
      }
    },
    changeCheckbox(checked, row) {
      if (this.selectType === 'radio') {
        return
      }
      if (checked) {
        this.addTag(row)
      } else {
        this.removeSelectedRow(row)
      }
    },
    checkAll(checked) {
      this.data.forEach(item => {
        if (checked) {
          this.addTag(item)
        } else {
          this.closeTag(item)
        }
      })
    }
  }
}
</script>